import gql from 'graphql-tag';

export const CREATE_LEADGEN_FORM_MUTATION = gql`
  mutation CreateLeadgenFormMutation(
    $articleId: ID!
    $leadgenFormTemplateId: ID!
    $bindingParams: BindingParamsInput!
  ) {
    createLeadgenForm(
      articleId: $articleId
      leadgenFormTemplateId: $leadgenFormTemplateId
      bindingParams: $bindingParams
    ) {
      leadgenForm {
        id
      }
      errors
    }
  }
`;
